import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Button from "../../AdminModule/Dashboard/AdminDashboard/Button";
import ReactStars from "react-rating-stars-component";
import "./styles.scss";
import { postStartUpFeedback } from "../../AdminModule/Dashboard/StartupDashboard/dependencies/action";
import swal from "sweetalert";

function MentorFeedBackModal(props) {
  const { postStartUpFeedback, feedBackData } = props;
  const [ratingData, setRatingData] = useState(0);
  const [ratingData2, setRatingData2] = useState(0);
  const [ratingData3, setRatingData3] = useState(0);
  const [ratingData4, setRatingData4] = useState(0);
  const [showError, setShowError] = useState(false);
  const handleClose = () => {
    props.setModalVisibility(false);
  };
  const ratingChanged = (newRating) => {
    setRatingData(newRating);
  };
  const handleSubmit = () => {
    if (
      ratingData !== 0 &&
      ratingData2 !== 0 &&
      ratingData3 !== 0 &&
      ratingData4 !== 0
    ) {
      setShowError(false);
      let params = {
        mentorId: props.mentorId,
        startupId: JSON.parse(localStorage.getItem("SavedLoggedInData")).id,
        mentorshipId: props.mentorshipId,
        overallRating: ratingData,
        mentorBehaviour: ratingData2,
        adviceAndGuidance: ratingData3,
        responsiveness: ratingData4,
        mentorshipStatus: "PENDING",
      };
      postStartUpFeedback(params);
      setTimeout(() => {
        swal({
          title: "Thank You",
          text: `Mentor Feedback Submitted Successfully`,
          icon: "success",
          // timer: 1500,
          // buttons: false,
        }).then(function () {
          // props.sendToParent(true);
          props.setModalVisibility(false);
          props.parentData(true);
        });
      }, 500);
    } else {
      setShowError(true);
    }
  };
  const firstExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value: (feedBackData !== undefined && feedBackData !== null)? feedBackData?.overallRating : 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData(newValue);
    },
  };
  const secondExample = {
    size: 35,
    count: 5,
    isHalf: false,
    value: (feedBackData !== undefined && feedBackData !== null) ? feedBackData?.mentorBehaviour : 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData2(newValue);
    },
  };
  const thirdExample = {
    size: 35,
    count: 5,
    isHalf: false,
    paddingLeft: 25,
    value: (feedBackData !== undefined && feedBackData !== null) ? feedBackData?.adviceAndGuidance : 0,
    color: "lightgray",
    activeColor: "orange",

    onChange: (newValue) => {
      setRatingData3(newValue);
    },
  };
  const fourthExample = {
    size: 35,
    count: 5,
    isHalf: false,
    paddingLeft: 25,
    value: (feedBackData !== undefined && feedBackData !== null) ? feedBackData?.responsiveness : 0,
    color: "lightgray",
    activeColor: "orange",
    onChange: (newValue) => {
      setRatingData4(newValue);
    },
  };
  return (
    <>
      <div className="modal-dialog modal-dialog-centered">
        <Modal
          size="lg"
          show={props.modalVisibility}
          onHide={() => props.setModalVisibility(false)}
          aria-labelledby="example-modal-sizes-title-lg"
          style={{ borderRadius: "7px" }}
        >
          <Modal.Header className="d-flex ">
            <Modal.Title className="modalHeading">MENTOR FEEDBACK</Modal.Title>
            <div className="newuserTooltip">
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleClose}
            />
            <span className="tooltiptext  close-window" style={{left:"-130px",top:"2px",width:"130px"}}>Close Window</span>
            </div>
          </Modal.Header>
          <Modal.Body>
            <div className="feedback-rating feedBackModalFix">
              <div className="row ">
                <div className="iconDiv">
                  <div>1</div>
                </div>
                <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                  Overall Mentor Rating*
                </div>
                <div
                  // style={{
                  //   textAlign: "left",
                  //   marginTop: "-15px",
                  //   marginLeft: "1.5rem",
                  // }}
                  className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                >
                  <ReactStars
                    {...firstExample}
                    edit={feedBackData !== undefined && feedBackData !== null ? false : true}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="iconDiv">
                  <div>2</div>
                </div>
                <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                  Mentor Behaviour & Professionalism*
                </div>
                <div
                  // style={{
                  //   textAlign: "left",
                  //   marginTop: "-15px",
                  //   marginLeft: "1.5rem",
                  // }}
                  className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                >
                  <ReactStars
                    {...secondExample}
                    edit={feedBackData !== undefined && feedBackData !== null ? false : true}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="iconDiv">
                  <div>3</div>
                </div>
                <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                  Advice & Guidance*
                </div>
                <div
                  // style={{
                  //   textAlign: "left",
                  //   marginTop: "-15px",
                  //   marginLeft: "1.5rem",
                  // }}
                  className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                >
                  <ReactStars
                    {...thirdExample}
                    edit={feedBackData !== undefined && feedBackData !== null ? false : true}
                  />
                </div>
              </div>
              <div className="row mt-3">
                <div className="iconDiv">
                  <div>4</div>
                </div>
                <div className="col col-lg-6 col-md-5 col-sm-10 col-10 rating-line modalHeadings78">
                  Responsiveness*
                </div>
                <div
                  // style={{
                  //   textAlign: "left",
                  //   marginTop: "-15px",
                  //   marginLeft: "1.5rem",
                  // }}
                  className="col col-lg-5 col-md-6 col-sm-12  col-12 reactstart starPositionFix"
                >
                  <ReactStars
                    {...fourthExample}
                    edit={feedBackData !== undefined && feedBackData !== null ? false : true}
                  />
                  {showError && (
                    <div className="login-error-msg mt-2">
                      Please Rate All Parameter
                    </div>
                  )}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer className="d-flex justify-content-center">
            <div className="d-flex justify-between feedBackFooterFix">
              {(feedBackData !== undefined && feedBackData !== null) ? (
                <Button
                  onClick={handleClose}
                  text="CLOSE"
                  className="modalButton3 doc-upload"
                ></Button>
              ) : (
                <>
                  <div>
                    <Button
                      onClick={handleClose}
                      text="BACK"
                      className="modalButton3 doc-upload"
                    ></Button>
                  </div>
                  <div>
                    <Button
                      onClick={handleSubmit}
                      text="SUBMIT"
                      className="modalButton3 doc-uploadnext"
                    ></Button>
                  </div>
                </>
              )}
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    getPredefineOptions: state.AdminMentorReducer.getPredefineOptionsList.list,
  };
};

export default connect(mapStateToProps, { postStartUpFeedback })(
  withRouter(MentorFeedBackModal)
);
